angular
    .module('empower.control')
    .directive("itemCount", ['$rootScope',
        function ($rootScope) {
            return {
                restrict: 'E',
                templateUrl: 'module/control/itemCount/item-count.html',
                scope: {
                    currentPage: '=',
                    rowPerPage: '=',
                    totalItems: '='
                },
                controller: function ($scope) {
                    $scope.startItem = ($scope.currentPage - 1) * $scope.rowPerPage + 1;
                    

                    $scope.startItem = function() {
                        return ($scope.currentPage - 1) * $scope.rowPerPage + 1;
                    }

                    $scope.endItem = function() {
                        var endItem =  $scope.currentPage * $scope.rowPerPage;
                        if(endItem > $scope.totalItems) {
                            endItem = $scope.totalItems;
                        }
                        return endItem;
                    }
                }, // controller
                link: function (scope, element, attrs) {} // link
            };
        }
    ])
